import { Directive, ViewContainerRef } from '@angular/core';

@Directive({ selector: '[phxDynamicComponent]' })
export class DynamicComponentDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
